import React from 'react';
import { SmDrawer } from '@smiles/smiles-react-design-system';

import useApi from '@/hooks/useApi';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { ButtonWithIcon } from '../ButtonWithIcon';

type TProps = {
  id: string;
  title: any;
  text: any;
  show: boolean;
  theme: string;
  onClose: () => void;
  recommendationId: string;
};

export const Modal = ({
  id,
  text,
  title,
  show,
  theme,
  onClose,
  recommendationId,
}: TProps) => {
  const { Api } = useApi();
  const handleClose = () => {
    if (recommendationId)
      dispatchInteraction(Api, 'click_modal_close', {
        recommendationId,
      });
    onClose();
  };
  return (
    <div className={`vitrine-template-${theme}`}>
      <SmDrawer
        className={`vitrine-template-${theme}__modal-content`}
        key={id}
        isOpen={show}
        onClose={onClose}
      >
        <div className={`vitrine-template-${theme}__modal-header`}>
          <ButtonWithIcon
            onClick={handleClose}
            isOutlined
            position="left"
            text=""
            icon={{ size: 'small', name: 'close' }}
          />
        </div>
        {typeof title === 'string' ? (
          <h4 className={`vitrine-template-${theme}__modal-title`}>{title}</h4>
        ) : (
          <>{title}</>
        )}
        {typeof text === 'string' ? (
          <section
            className={`vitrine-template-${theme}__modal-text`}
            dangerouslySetInnerHTML={{ __html: `${text}` }}
          />
        ) : (
          <>{text}</>
        )}
      </SmDrawer>
    </div>
  );
};
